export default{
  banks: (state) => state.banks
}



// WEBPACK FOOTER //
// ./src/components/bank/store/getters.js